export default __webpack_public_path__ + "static/media/itsazuretime.c29af051.png";